import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "专区导航", to: "/zones" },
  { label: "热榜", to: "/ranking" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative text-sm transition-colors whitespace-nowrap cursor-pointer ${
      isActive
        ? "text-primary-700 font-medium"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <>
      <div className="bg-foreground-900 text-background-100">
        <div className="w-full px-4 md:px-8 h-9 flex items-center justify-between gap-4">
          <p className="flex items-center gap-2 text-xs truncate">
            <i className="ri-fire-fill text-accent-400"></i>
            <span className="truncate">爆料91专区已开启 · 栏目合集板块全收录</span>
          </p>
          <div className="hidden md:flex items-center gap-5 text-xs text-background-200">
            <Link to="/zones" className="hover:text-background-50 transition-colors cursor-pointer">
              专区总览
            </Link>
            <Link to="/about" className="hover:text-background-50 transition-colors cursor-pointer">
              编辑邮箱
            </Link>
          </div>
        </div>
      </div>

      <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/80">
        <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer" aria-label="爆料91首页">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-600 text-background-50 flex items-center justify-center">
              <i className="ri-fire-fill text-lg md:text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-wide">
                爆料91
              </span>
              <span className="text-[10px] md:text-[11px] text-foreground-500 font-label tracking-wider">
                BAOLIAO 91
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/zones"
              className="hidden sm:inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors"
            >
              <i className="ri-layout-grid-fill"></i>
              进入专区
            </Link>
            <button
              type="button"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-900 cursor-pointer hover:bg-background-100 transition-colors"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
            </button>
          </div>
        </div>

        {open && (
          <nav
            className="lg:hidden border-t border-background-200 bg-background-50 px-4 md:px-8 py-4 flex flex-col gap-1"
            aria-label="移动端导航"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between px-3 py-3 rounded-md text-sm cursor-pointer ${
                    isActive
                      ? "bg-primary-50 text-primary-700 font-medium"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </NavLink>
            ))}
            <Link
              to="/zones"
              className="mt-2 flex items-center justify-center gap-1.5 h-11 rounded-md bg-primary-600 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-700 transition-colors"
            >
              <i className="ri-layout-grid-fill"></i>
              进入专区
            </Link>
          </nav>
        )}
      </header>
    </>
  );
}